module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_amal-eea9b95eda2b1d18277df95ce8f61498.png";